<script lang="ts">
	import '$styles/global.css';
	import '@awesome.me/kit-f1d1181ead/icons/css/all.min.css';
	import { page } from '$app/stores';
	import Cookies from '$components/Cookies.svelte';
	import DesktopNav from '$components/DesktopNav.svelte';
	import MobileNav from '$components/MobileNav.svelte';
	import Search from '$components/Search.svelte';
	import Cart from '$components/Cart.svelte';
	import ToastHolder from '$components/toastHolder.svelte';
	import { isCartOpen } from '$stores/cartComponentManager';
	import { cart } from '$stores/cart';

	export let data;
</script>

<ToastHolder />

<Cookies />

<header class="border-b border-gray-200 bg-gray-100">
	<a class="sr-only" href="#main">Skip to content</a>
	<Cart />
	<div class="flex flex-row">
		<div class="flex w-[50%] md:w-[15%]">
			<a href="/"
				><img
					class="h-full w-full object-cover object-center"
					data-src="https://takethecake.gumlet.io/resources/logo.webp"
					alt="Take the cake logo"
				/></a
			>
		</div>
		<div class="flex flex-col md:hidden">
			<span class="ml-auto mr-[4vw] mt-[4vw]">
				<button
					aria-haspopup="dialog"
					id="mobilecartButton"
					aria-label={$cart.items.length > 0
						? 'Cart ' + $cart.items.length
						: 'Cart'}
					on:click={() => {
						isCartOpen.set(true);
					}}
				>
					<span class="fa-duotone fa-cart-shopping text-logoBackgroundBlue" />
					{#if $cart.items.length > 0}
						<sup
							aria-hidden="true"
							class="rounded-full bg-logoFontPurple px-1 text-xs text-white"
						>
							{$cart.items.length}
						</sup>
					{/if}
				</button>
			</span>
			<span class="my-auto ml-auto mr-[2vw]"
				><Search resultsList={data.productsBasics} /></span
			>
		</div>
		<div class="hidden w-full md:flex">
			<DesktopNav searchData={data.productsBasics} />
		</div>
	</div>
	<MobileNav />
</header>

<main id="main" class="my-5 flex-grow">
	<slot />
</main>

<footer
	class="space-y-5 border-t border-gray-200 bg-gray-100 px-[2vw] pb-5 text-center md:space-y-8 md:pb-8"
>
	<div class="mt-5 md:mt-8">
		<div class="flex flex-col">
			<h2 class="mb-2 font-medium leading-none text-gray-900 md:mt-0">
				Contact Us
			</h2>
			<div class="flex flex-row md:my-auto">
				<a
					class="mx-0.5 ml-auto px-1.5 py-0 leading-none md:flex md:gap-2"
					href="mailto:krissy@takethecake.ie"
					aria-label="Email"
					><span class="fa-duotone fa-envelopes text-logoBackgroundBlue" /><span
						class="hidden text-gray-800 hover:text-gray-600 focus:text-gray-600 md:inline"
					>
						krissy@takethecake.ie</span
					></a
				>
				<a
					class="mx-0.5 px-1.5 leading-none md:flex md:gap-2"
					href="tel:+353862113375"
					aria-label="Phone"
					><span class="fa-duotone fa-phone text-logoBackgroundBlue" /><span
						class="hidden text-gray-800 hover:text-gray-600 focus:text-gray-600 md:inline"
					>
						086 211 3375</span
					></a
				>
				<a
					class="mx-0.5 px-1.5 leading-none md:flex md:gap-2"
					href="https://www.facebook.com/takethecakedublin/"
					aria-label="Facebook"
					><span class="fa-brands fa-facebook text-logoBackgroundBlue" /><span
						class="hidden text-gray-800 hover:text-gray-600 focus:text-gray-600 md:inline"
					>
						Take The Cake - Dublin</span
					></a
				>
				<a
					class="mx-0.5 px-1.5 leading-none md:flex md:gap-2"
					href="https://www.threads.net/@takethecakedublin"
					aria-label="Threads"
					><span class="fa-brands fa-threads text-logoBackgroundBlue" /><span
						class="hidden text-gray-800 hover:text-gray-600 focus:text-gray-600 md:inline"
					>
						takethecakedublin</span
					></a
				>
				<a
					class="mx-0.5 mr-auto px-1.5 leading-none md:flex md:gap-2"
					href="https://www.instagram.com/takethecakedublin/"
					aria-label="Instagram"
					><span class="fa-brands fa-instagram text-logoBackgroundBlue" /><span
						class="hidden text-gray-800 hover:text-gray-600 focus:text-gray-600 md:inline"
					>
						takethecakedublin</span
					></a
				>
			</div>
		</div>
		<p class="mt-2 text-sm text-gray-700">
			* We typically respond to emails faster than other inquiries. Email us for
			the quickest answer!
		</p>
	</div>
	<div
		class="mx-auto h-[2px] w-[100%] bg-gradient-to-r from-transparent via-gray-300 to-transparent"
	></div>
	<div class="flex flex-col gap-2 md:flex-row md:justify-center md:gap-14">
		<p class="text-xs text-gray-700 sm:mt-0">
			&copy; 2019 - {new Date().getFullYear()}. Take the Cake ®. All rights
			reserved.
		</p>

		<ul class="mx-auto flex flex-wrap gap-4 text-xs md:mx-0">
			<li>
				<a
					href="/terms"
					class="text-gray-700 hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
				>
					Terms & Conditions
				</a>
			</li>

			<li>
				<a
					href="/privacy"
					class="text-gray-700 hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
				>
					Privacy Policy
				</a>
			</li>

			<li>
				<a
					href="/cookies"
					class="text-gray-700 hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
				>
					Cookies Policy
				</a>
			</li>
		</ul>

		<a
			href="https://envisionly.tech"
			class="text-xs text-gray-700 hover:text-logoBackgroundBlue focus:text-logoBackgroundBlue"
			>Created by Envisionly
		</a>
	</div>
	<a class="sr-only" href="#main">Return to content</a>
</footer>

<style>
	:global(summary::marker) {
		display: none;
	}

	:global(summary::-webkit-details-marker) {
		display: none;
	}

	:global(details summary) {
		list-style: none;
	}
</style>
